import { SimpleLocalizedError } from "@/modules/l10n/getTransText.ts";
import { msg } from "@lingui/core/macro";

export class DigioLoadError extends SimpleLocalizedError {
    name = "DigioLoadError";
    constructor(options?: ErrorOptions) {
        super(msg`Failed to load Digio library`, options);
    }
}
